import { render, staticRenderFns } from "./AuroraLayout.vue?vue&type=template&id=7cb11da1"
import script from "./AuroraLayout.vue?vue&type=script&lang=js"
export * from "./AuroraLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports